module.exports = __webpack_public_path__ + "img/defaultAvatar.3fcdf9d0.png";